import React from "react";
import SecondaryHeading from "../../components/common/Typography/SecondaryHeading";
import Paragraph from "../../components/common/Typography/Paragraph";

import CardIcon from "../../assets/img/payment/master.svg";
import ApplePayIcon from "../../assets/img/payment/Applepay.svg";
import GooglePayIcon from "../../assets/img/payment/Googlepay.svg";
import AfterpayIcon from "../../assets/img/payment/Afterpay.svg";
import ZipIcon from "../../assets/img/payment/zippay.svg";
import KlarnaIcon from "../../assets/img/payment/klarna.svg";
import PayIDIcon from "../../assets/img/payment/payid.svg";
import BankTransferIcon from "../../assets/img/payment/banktransfer.svg";
import CashIcon from "../../assets/img/payment/cash.svg";

const Payment = () => {
  const data = [
    { heading: "Card", pic: CardIcon },
    { heading: "Apple Pay", pic: ApplePayIcon },
    { heading: "Google Pay", pic: GooglePayIcon },
    { heading: "Afterpay", pic: AfterpayIcon },
    { heading: "Zip", pic: ZipIcon },
    { heading: "Klarna", pic: KlarnaIcon },
    { heading: "PayID", pic: PayIDIcon },
    { heading: "Bank Transfer", pic: BankTransferIcon },
    { heading: "Cash", pic: CashIcon },
  ];
  return (
    <>
      <SecondaryHeading
        variant={"MainParagraphHeading"}
        className={"text-offblack mb-3"}
      >
        Payment Methods
      </SecondaryHeading>
      <div className="flex flex-col gap-4 items-start">
        {data.map((e, index) => (
          <div
            key={index}
            className="flex flex-row items-center gap-3 group transition-colors duration-200"
          >
            <img src={e.pic} alt={e.heading} className="h-7 w-auto object-contain" />
            <Paragraph
              variant={"MainParagraph"}
              className={"text-offblack text-sm transition-colors duration-200"}
            >
              {e.heading}
            </Paragraph>
          </div>
        ))}
      </div>
    </>
  );
};

export default Payment;
